
import teamCustomCursor from '@/mixins/teamCustomCursor.js';
import CustomCursorSVG from "static/images/custom_cursor-team.svg?inline";
import {getImageOfSize, getMemberPhotoAttributes} from "@/utils/getImagePaths.js";

export default {
  name: "TeamMemberItem",
  // ToDo move this cursor to the parent component (no need to load CustomCursorMixin for each member?)
  mixins: [teamCustomCursor],
  components: {CustomCursorSVG},
  props: {
    index: Number,
    member: Object,
    showDoodle: Boolean
  },
  watch: {
    showDoodle(value) {
      if (value) {
        // Show Doodle
        this.handleMouseOver();
      } else if (!this.$device.isMobile) {
        // Hide Doodle
        this.handleMouseOut();
      }
    }
  },
  methods: {
    getImageOfSize,
    getMemberPhotoAttributes,
    triggerDetailsModal() {
      this.$emit('update-active-member', this.index);
    },
  }
}
